module.exports = __webpack_public_path__ + "01543f9a81d0548e227a7bfeb4aa185c.pdf";